import { render, staticRenderFns } from "./SetVerificationForm.vue?vue&type=template&id=03f651d9&"
import script from "./SetVerificationForm.vue?vue&type=script&lang=js&"
export * from "./SetVerificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports